export default {
  zh: {
    OVERDUE_TODAY: '未完成 + 今天',
    OVERDUE: '未完成',
    TODAY: '今天',
    THIS_MONTH: '这个月',
    THIS_WEEK: '这周',
    ALL: '全部',
    TOMORROW: '明天',
    myOpenActivity: '待办事项',
    allMembers: '全部组员',
    assignTo: '任务分配给',
    total: '总数',
    CUSTOMIZE: '时间段',
    cancel: '取消',
    confirm: '确认'
  },
  en: {
    OVERDUE_TODAY: 'Overdue + Today',
    OVERDUE: 'Overdue',
    TODAY: 'Today',
    THIS_MONTH: 'This Month',
    THIS_WEEK: 'This Week',
    ALL: 'All',
    TOMORROW: 'Tomorrow',
    myOpenActivity: 'Open Tasks',
    allMembers: 'All Members',
    assignTo: 'Assign To',
    total: 'Total',
    CUSTOMIZE: 'Range...',
    cancel: 'Cancel',
    confirm: 'Confirm'
  },
};



// WEBPACK FOOTER //
// ./src/views/Task/i18n.js